import { urls } from './urls';

const carouselImages = {
  SemanaAmbimaLavagemDeDinheiro: [
    {
      imagem: `${urls.assets}img/carousel-images/SemanaAmbimaLavagemDeDinheiro-01.png`,
      descricao: 'CVM e o uso da abordagem baseada em risco',
    },

    {
      imagem: `${urls.assets}img/carousel-images/SemanaAmbimaLavagemDeDinheiro-02.png`,
      descricao: 'Norma do BC e avaliação de risco pelas instituições',
    },

    {
      imagem: `${urls.assets}img/carousel-images/SemanaAmbimaLavagemDeDinheiro-03.png`,
      descricao: 'O olhar da BSM sobre as novas regras',
    },

    {
      imagem: `${urls.assets}img/carousel-images/SemanaAmbimaLavagemDeDinheiro-04.png`,
      descricao: 'Impactos na Lei do Sigilo Bancário e na LGPD',
    },

    {
      imagem: `${urls.assets}img/carousel-images/SemanaAmbimaLavagemDeDinheiro-05.png`,
      descricao: 'As boas práticas da ANBIMA',
    },
  ],

  NovaRealidadeDaIndustriaDeFundos: [
    {
      imagem: `${urls.assets}img/carousel-images/NovaRealidadeDaIndustriaDeFundos-01.png`,
      descricao: 'Efeitos do home office nas assets',
    },

    {
      imagem: `${urls.assets}img/carousel-images/NovaRealidadeDaIndustriaDeFundos-02.png`,
      descricao: 'Desafios da volta ao escritório',
    },

    {
      imagem: `${urls.assets}img/carousel-images/NovaRealidadeDaIndustriaDeFundos-03.png`,
      descricao: 'Segurança cibernética em tempos de pandemia',
    },

    {
      imagem: `${urls.assets}img/carousel-images/NovaRealidadeDaIndustriaDeFundos-04.png`,
      descricao: 'Aprendizados e lições na crise',
    },
  ],

  serieFalaCvm: [
    {
      imagem: `${urls.assets}img/carousel-images/serieFalaCvm-01.png`,
      descricao: 'Atuação da CVM na pandemia',
    },

    {
      imagem: `${urls.assets}img/carousel-images/serieFalaCvm-02.png`,
      descricao: 'Influenciadores digitais e recomendação de investimentos',
    },

    {
      imagem: `${urls.assets}img/carousel-images/serieFalaCvm-03.png`,
      descricao: 'Nova regulação de fundos',
    },
  ],

  temasDiversosUm: [
    {
      imagem: `${urls.assets}img/carousel-images/temasDiversosUm-01.png`,
      descricao: 'Reações da economia à Covid-19 e previsões para o ano',
    },

    {
      imagem: `${urls.assets}img/carousel-images/temasDiversosUm-02.png`,
      descricao: 'BNDES oferece oportunidade para fundos imobiliários',
    },
  ],

  temasDiversosDois: [
    {
      imagem: `${urls.assets}img/carousel-images/temasDiversosDois-01.png`,
      descricao: 'Regulação das companhias securitizadoras',
    },

    {
      imagem: `${urls.assets}img/carousel-images/temasDiversosDois-02.png`,
      descricao: 'Guias ANBIMA: padronização de debentures e formador de mercado',
    },
  ],

  temasDiversosTres: [
    {
      imagem: `${urls.assets}img/carousel-images/temasDiversosTres-01.png`,
      descricao: 'Tira-dúvidas: novas regras de gestão de carteiras administradas',
    },

    {
      imagem: `${urls.assets}img/carousel-images/temasDiversosTres-02.png`,
      descricao: 'Insights 2021: a transformação no trabalho e os ganhos para o mercado',
    },
  ],

  destaqueDaSemana: [
    {
      imagem: `${urls.assets}img/carousel-images/destaqueDaSemana-01.png`,
      descricao: 'Especial CNF',
    },

    {
      imagem: `${urls.assets}img/carousel-images/destaqueDaSemana-02.png`,
      descricao: 'Prioridades da supervisão na Distribuição',
    },

    {
      imagem: `${urls.assets}img/carousel-images/destaqueDaSemana-03.png`,
      descricao: 'Autorregulação nos mercados organizados de bolsa de valores, balcão e infraestrutura',
    },

    {
      imagem: `${urls.assets}img/carousel-images/destaqueDaSemana-04.png`,
      descricao: 'Raio X do investidor brasileiro',
    },

    {
      imagem: `${urls.assets}img/carousel-images/destaqueDaSemana-05.png`,
      descricao: 'Portabilidade de investimentos',
    },

    {
      imagem: `${urls.assets}img/carousel-images/destaqueDaSemana-06.png`,
      descricao: 'Nova certificação para gestores de recursos',
    },
  ],
};

export default carouselImages;
